import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TOUR_FEATURE_MAP, VISITED_PAGES_KEY } from '../constants/tourGuide';
import { useTour } from '../components/TourProvider';

export const useTourGuide = () => {
  const location = useLocation();
  const { showFeatureTour } = useTour();
  const { userData } = useSelector((store) => store.auth);
  const userId = userData?.id?.toString() || 'default';

  useEffect(() => {
    const currentPath = location.pathname;

    // Find matching feature by prefix
    let featureName = null;
    let matchedPrefix = null;
    const sortedPrefixes = Object.keys(TOUR_FEATURE_MAP).sort((a, b) => b.length - a.length);
    for (const prefix of sortedPrefixes) {
      if (currentPath === prefix || currentPath.startsWith(prefix + '/')) {
        featureName = TOUR_FEATURE_MAP[prefix];
        matchedPrefix = prefix;
        break;
      }
    }

    if (!featureName || !matchedPrefix) return;

    const visitedKey = `${VISITED_PAGES_KEY}_${userId}`;
    const visitedPages = JSON.parse(localStorage.getItem(visitedKey) || '[]');

    if (!visitedPages.includes(matchedPrefix)) {
      setTimeout(() => {
        showFeatureTour(featureName);
        visitedPages.push(matchedPrefix);
        localStorage.setItem(visitedKey, JSON.stringify(visitedPages));
      }, 1500);
    }
  }, [location.pathname, showFeatureTour, userId]);
};
